'use strict';

// NOTE: These types should be in-sync with the semantic-grid themes in Supernova
exports.SCREEN_SIZES = void 0;
(function(SCREEN_SIZES) {
    SCREEN_SIZES["mobile375"] = "mobile375";
    SCREEN_SIZES["tablet834"] = "tablet834";
    SCREEN_SIZES["desktop1024"] = "desktop1024";
    SCREEN_SIZES["desktop1280"] = "desktop1280";
})(exports.SCREEN_SIZES || (exports.SCREEN_SIZES = {}));
const MIN_BREAKPOINTS = {
    ["mobile375"]: 375,
    ["tablet834"]: 834,
    ["desktop1024"]: 1024,
    ["desktop1280"]: 1280
};

exports.MIN_BREAKPOINTS = MIN_BREAKPOINTS;
//# sourceMappingURL=breakpoints.cjs.map
